import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import TextField from 'material-ui/TextField';

import AppConstants from '../../constants/AppConstants';

const styles = {
  radioButton: {
    marginBottom: 4,
    marginLeft: 12,
  },
  errorStyle: {
    color: AppConstants.colors.accent1Color,
  },
  inputStyle: {
    color: AppConstants.colors.primary1Color,
  }
}

class PoiFormRadiusChar extends Component {

  static propTypes = {
    defaultValue: PropTypes.string.isRequired,
    /**
     * Change callback
     * @param {String} value
     */
    onChange: PropTypes.func.isRequired,
    /**
     * Show 'Same as original' option
     */
    showSame: PropTypes.bool,    
    /**
     * Show 'Auto-detect' option
     */
    showAuto: PropTypes.bool,    
  }

  constructor(props) {
    super(props);
    this.state = {
      radiusChar: props.defaultValue,
      radiusCustomChar: '',
      customRadiusErrorText: '',
    };
  }

  setRadiusCharToOther = () => {
    this.setState({
      radiusChar: 'other',
    })
    this.props.onChange(this.state.radiusCustomChar);
  }

  handleRadiusChange = (event, val) => {
    this.setState({ radiusChar: val });
    // Bring focus to textfield when other is selected
    if (val === 'other' && this.refs.customRadius) {
      this.refs.customRadius.focus();
    } else {
      this.props.onChange(val);
    }
  }

  handleCustomRadiusChange = (e, val) => {
    let newVal = val.replace(/[^\d]*/g, ''); // only allow numbers
    let customRadiusErrorText = '';
    if (newVal !== val) {
      customRadiusErrorText = 'Please input a number';
      val = newVal;
    }
    // TODO: change this into stepped slider (material UI)
    this.setState({ radiusCustomChar: val, customRadiusErrorText });
    this.props.onChange(val);
  }

  render() {
    styles.optionalSameButton = Object.assign({}, styles.radioButton);
    styles.optionalAutoButton = Object.assign({}, styles.radioButton);
    if (!this.props.showSame) {
      styles.optionalSameButton.display = 'none';
    }
    if (!this.props.showAuto) {
      styles.optionalAutoButton.display = 'none';
    }

    return (
      <div>
        <RadioButtonGroup
          name="radius_char"
          valueSelected={this.state.radiusChar}
          onChange={this.handleRadiusChange}
        >
          <RadioButton
            value="1000"
            label="1,000m"
            style={styles.radioButton}
          />
          <RadioButton
            value="100"
            label="100m"
            style={styles.radioButton}
          />
          <RadioButton
            value="10"
            label="10m"
            style={styles.radioButton}
          />
          <RadioButton
            value="other"
            label="Other:"
            style={styles.radioButton}
          />
        </RadioButtonGroup>
        <TextField
          ref="customRadius"
          hintText="Enter your custom radius (10-1000)"
          errorStyle={styles.errorStyle}
          value={this.state.radiusCustomChar}
          errorText={this.state.errorText}
          maxLength={4}
          onFocus={this.setRadiusCharToOther}
          onChange={this.handleCustomRadiusChange}
        />
      </div>
    );
  }
}
export default PoiFormRadiusChar;



// WEBPACK FOOTER //
// ./src/components/PoiFormRadiusChar/index.jsx